import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { Router, RouterStateSnapshot } from "@angular/router";
import { ActivatedRoute, NavigationExtras } from "@angular/router";
import { trigger, transition, animate, style } from "@angular/animations";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  animations: [
    trigger("slideInOut", [
      transition(":enter", [style({ transform: "translateY(100%)" })]),
      transition(":leave", [
        animate("1000ms ease-in", style({ transform: "translateY(100%)" })),
      ]),
    ]),
  ],
})
export class HomeComponent implements OnInit {
  showFiller = true;
  panelOpenState = true;
  sideNavOption: any;
  panelHeaderHeight = "43px";
  selectedPanel: string | null = null;

  constructor(
    fb: FormBuilder,
    private router: Router,
    private _route: ActivatedRoute,
    private _router: Router,
    private _formBuilder: FormBuilder,
    // private store: Store
  ) {
    this.sideNavOption = fb.group({
      top: 0,
      bottom: 0,
      fixed: false,
    });
  }

  ngOnInit() {}

  logout() {
    localStorage.clear();
    // this.store.dispatch(logout()); // Dispatch logout action

    this.router.navigateByUrl("login");
  }

  home() {
    this.router.navigateByUrl("login");
  }

  appList() {
    this.router.navigateByUrl("home/applist");
    this.selectedPanel = "application";
  }

  metaobjectList() {
    this.router.navigateByUrl("home/metaobjectlist");
    this.selectedPanel = "metaobject";
  }

  globalAction() {
    this.router.navigateByUrl("home/globalaction");
    this.selectedPanel = "globalaction";
  }
  input_field() {
    this.router.navigateByUrl("home/input_field");
  }
  searchLayout() {
    this.router.navigateByUrl("home/searchlayout");
    this.selectedPanel = "searchlayout";
  }
  processes() {
    this.router.navigateByUrl("home/processes");
    this.selectedPanel = "process";
  }

  reportTypes() {
    this.router.navigateByUrl("home/reporttypes");
    this.selectedPanel = "reporttype";
  }

  report() {
    this.router.navigateByUrl("home/reports");
    this.selectedPanel = "report";
  }
  convertSetting() {
    this.router.navigateByUrl("home/convertsettinglist");
    this.selectedPanel = "convertsetting";
  }
  dashboard() {
    this.router.navigateByUrl("home/dashboardlist");
    this.selectedPanel = "dashboard";
  }
  matchingrule() {
    this.router.navigateByUrl("home/matchingrulelist");
    this.selectedPanel = "matchingrule";
  }
  duplicaterule() {
    this.router.navigateByUrl("home/duplicaterulelist");
    this.selectedPanel = "duplicaterule";
  }
  crudmessage() {
    this.router.navigateByUrl("home/crudmessagelist");
    this.selectedPanel = "crudmessage";
  }
  errormessage() {
    this.router.navigateByUrl("home/errormessagelist");
    this.selectedPanel = "errormessage";
  }
  sectionroot() {
    this.router.navigateByUrl("home/sectionrootlist");
    this.selectedPanel = "sectionroot";
  }
  modulesetting() {
    this.router.navigateByUrl("home/modulesettinglist");
    this.selectedPanel = "modulesetting";
  }
  wizardlayout() {
    this.router.navigateByUrl("home/wizardlayoutlist");
    this.selectedPanel = "wizardlayout";
  }

  domainsetting() {
    this.router.navigateByUrl("home/domainsettinglist");
    this.selectedPanel = "domainsetting";
  }
  errorcode() {
    this.router.navigateByUrl("home/errorcodelist");
    this.selectedPanel = "errorcode";
  }
}
